import React, { useEffect, useState } from 'react';
import { isEmpty, isUndefined } from 'lodash';

import FormControlLabel from '@mui/material/FormControlLabel';
import LessonComponentService from '../../../services/LessonComponentService';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { SelectionComponentProps } from '../../../models/LessonComponent';
import { SelectionOption } from '../../../models/LessonComponentContent';
import styles from '../../../styles/SelectionCard.module.css';
import { useTheme } from '@mui/material';

export default function SingleSelectionView(props: SelectionComponentProps) {
  const muiTheme = useTheme();
  const primaryColor = muiTheme.palette.primary.main;
  const paragraphStyle = muiTheme.typography.custom1;

  const { content, settings } = props.component;
  const setSelectionOptions = () => {
    const newOptions = settings?.randomizeOptions
      ? LessonComponentService.randomizeSelectionOptions(content?.options)
      : content?.options;
    return newOptions;
  };
  const [options, setOptions] = useState<SelectionOption[]>(
    setSelectionOptions() || []
  );
  const [selected, setSelected] = useState<string>(
    (props.response as string) || null
  );
  const radioGroupName = `group-${props.component.componentkey}`;

  useEffect(() => {
    if (!isEmpty(options)) {
      return;
    }
    const selectionOptions = setSelectionOptions();
    setOptions(selectionOptions);
  }, [props.component.content?.options]);

  useEffect(() => {
    if (!isUndefined(props.response)) {
      setSelected(props.response as string);
    }
  }, [props.response]);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    if (checked) {
      const value = event.target.value;
      props.onChange(value);
      setSelected(value);
    }
  };

  return (
    <>
      <RadioGroup name={radioGroupName} value={selected}>
        {options?.map((option) => (
          <div
            key={`${radioGroupName}-${option.value}`}
            style={{
              ...(settings.selectionSettings?.showBorder &&
                LessonComponentService.optionBorderColor(
                  option.value,
                  [selected],
                  primaryColor
                ))
            }}
            className={
              settings.selectionSettings?.showBorder ? styles.labelBorder : ''
            }
          >
            <FormControlLabel
              key={`${radioGroupName}-${option.value}`}
              value={option.value}
              control={<Radio color="primary" />}
              label={
                <div
                  className={`${styles.muiFormControlLabel} ${styles.itemLabel}`}
                  style={paragraphStyle}
                >
                  <span
                    className="formatted-label ql-editor"
                    dangerouslySetInnerHTML={{
                      __html: LessonComponentService.getUrlWithSas(option.label)
                    }}
                  ></span>
                </div>
              }
              onChange={handleChange}
              style={{ width: '100%' }}
            />
          </div>
        ))}
      </RadioGroup>
    </>
  );
}
